"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishSummaryTile = void 0;
const react_1 = __importDefault(require("react"));
const merlin_tile_1 = require("@travelnest/merlin.tile");
const Pad_1 = require("../styles/Pad");
const Heading_1 = require("../heading/Heading");
const Spacer_1 = require("../spacer/Spacer");
const Paragraph_1 = require("../paragraph/Paragraph");
const Button_1 = require("../button/Button");
const time_1 = require("../../../util/time");
const util_1 = require("./util");
const Publish_1 = require("../../pages/dashboard/Publish");
const PublishTile = ({ property, onPublishClick }) => {
    return react_1.default.createElement(merlin_tile_1.Tile, null,
        react_1.default.createElement(Pad_1.Pad, null,
            react_1.default.createElement(Heading_1.Heading, null, "Publish your changes"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null, "You have made changes to this property which have not been published to your channels"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: onPublishClick }, "Publish changes now"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            !!property.published_at &&
                react_1.default.createElement(Paragraph_1.Paragraph, null,
                    react_1.default.createElement("small", null,
                        "Last published ",
                        (0, time_1.getLastPublishedMessage)((0, time_1.fromUTC)(new Date(property.published_at)))))));
};
const SuccessTile = () => {
    return react_1.default.createElement(merlin_tile_1.Tile, null,
        react_1.default.createElement(Pad_1.Pad, null,
            react_1.default.createElement(Heading_1.Heading, null, "Changes published"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null, "Your changes have been published to your selected channels")));
};
const ErrorTile = () => {
    return react_1.default.createElement(merlin_tile_1.Tile, null,
        react_1.default.createElement(Pad_1.Pad, null,
            react_1.default.createElement(Heading_1.Heading, null, "Something went wrong"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null, "There was an error publishing your changes. Please try again, or contact support for further help.")));
};
const PropertyInvalidTile = () => {
    return react_1.default.createElement(merlin_tile_1.Tile, null,
        react_1.default.createElement(Pad_1.Pad, null,
            react_1.default.createElement(Heading_1.Heading, null, "Fix any issues"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null, "There are issues with your property data. Look out for sections which require attention below, and make any required changes before publishing your property again.")));
};
const UpToDateTile = ({ property }) => {
    return react_1.default.createElement(merlin_tile_1.Tile, null,
        react_1.default.createElement(Pad_1.Pad, null,
            react_1.default.createElement(Heading_1.Heading, null, "Property is up to date"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null, "If you make changes to any of your property information, we'll let you publish them to your selected channels."),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Button_1.Button, { disabled: true }, "Publish changes now"),
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(Paragraph_1.Paragraph, null,
                react_1.default.createElement("small", null,
                    "Last published ",
                    (0, time_1.getLastPublishedMessage)((0, time_1.fromUTC)(new Date(property.published_at)))))));
};
const PublishSummaryTile = ({ property, readyToPublish }) => {
    const [showSuccessTile, setShowSuccessTile] = react_1.default.useState(false);
    const [showErrorTile, setShowErrorTile] = react_1.default.useState(false);
    const hasChanges = (0, util_1.propertyNeedsToPublish)(property);
    react_1.default.useEffect(() => {
        if ((showSuccessTile || showErrorTile) && hasChanges) {
            setShowSuccessTile(false);
            setShowErrorTile(false);
        }
    }, [hasChanges]);
    return react_1.default.createElement(react_1.default.Fragment, null, !readyToPublish ? react_1.default.createElement(PropertyInvalidTile, null) :
        showSuccessTile ? react_1.default.createElement(SuccessTile, null) :
            showErrorTile ? react_1.default.createElement(ErrorTile, null) :
                !hasChanges ? react_1.default.createElement(UpToDateTile, { property: property }) :
                    react_1.default.createElement(PublishTile, { property: property, onPublishClick: () => {
                            const button = document.getElementById(Publish_1.SCROLL_TO_BUTTON_ID);
                            if (button) {
                                button.scrollIntoView({ behavior: 'smooth' });
                                return;
                            }
                            window.scroll({ top: document.getElementsByTagName('body')[0].clientHeight, behavior: 'smooth' });
                            return;
                        } }));
};
exports.PublishSummaryTile = PublishSummaryTile;
//# sourceMappingURL=PublishSummaryTile.js.map